
import Navbar from "@/components/Navbar";
import NewHero from "@/components/NewHero";
import NewConcept from "@/components/NewConcept";
import NewHowItWorks from "@/components/NewHowItWorks";
import NewStory from "@/components/NewStory";
import NewBenefits from "@/components/NewBenefits";
import TestimonialsCarousel from "@/components/TestimonialsCarousel";
import NewUrgency from "@/components/NewUrgency";
import NewCallToAction from "@/components/NewCallToAction";
import ContactRepresentative from "@/components/ContactRepresentative";
import Footer from "@/components/Footer";

const NewNarrative = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar activePage="new-narrative" />
      <NewHero />
      <NewConcept />
      <NewHowItWorks />
      <NewStory />
      <NewBenefits />
      <TestimonialsCarousel />
      <NewUrgency />
      <NewCallToAction />
      <ContactRepresentative />
      <Footer />
    </div>
  );
};

export default NewNarrative;
